import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { useLocation } from 'react-router-dom';

const StyledMain = styled.main`
  position: relative;
  background: ${({ theme }) => theme.colors.cultured};
  height: 100vh;

  @supports (height: 100svh) {
    height: 100svh;
  }
`;

const Main: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const ref = useRef<HTMLDivElement>(null);
  const prevPathnameRef = useRef<string>();

  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (ref.current && !hash && prevPathnameRef.current && prevPathnameRef.current !== pathname) {
      ref.current.scrollTo(0, 0);
    }
    prevPathnameRef.current = pathname;
  }, [pathname, hash]);

  return (
    <StyledMain ref={ref} id="main">
      {children}
    </StyledMain>
  );
};

export default Main;
